<template>
  <div>
    <el-drawer :visible.sync="drawer" id="checkInfo" custom-class="el-drawer" size="840px" v-if="drawer"
      @close="closeDrawer">
      <div slot="title">
        <dealTitle :data="getByIdFullData"></dealTitle>
      </div>
      <div style="padding: 0 0 20px 0px;">
        <el-tag type="warning" style="width: 100%;">
          <img src="../../../assets/img/other/trumpet_icon.png" style="margin-left: 13px;margin-right: 5px;">
          <span>请仔细核对举报信息与店铺是否匹配，不匹配请及时调整或驳回，避免造成恶意举报。</span>
        </el-tag>
      </div>
      <!-- 举报信息 -->
      <commonReportInfo :data="getByIdFullData" :showChangeInfo="activeName == 'first' ? true : false"
        @changeRepetitionShow="changeRepetitionShow" @firstTrialInfo="firstTrialInfo" @loadPage='loadPage'>
        <div slot="other">
          <el-form-item label="举报人：">{{ getByIdFullData.creatuser }}</el-form-item>
          <el-form-item label="举报时间：">{{ getByIdFullData.createtime | fullTime }}</el-form-item>
        </div>
      </commonReportInfo>
      <!-- 初审信息 -->
      <div class="drawer-subtitle_common">
        <span class="drawer-subtitle-text">初审信息</span>
      </div>
      <!-- 未初审 -->
      <div v-if="activeName === 'first'">
        <div style="padding: 40px 0 20px 0px;">
          <el-tag type="warning" style="width: 100%;">
            <img src="../../../assets/img/other/trumpet_icon.png" style="margin-left: 13px;margin-right: 5px;">
            <span>当前店铺为{{ getByIdFullData.shoptype != 1 ? '非' : '' }}授权店铺，接受举报后将按照{{ getByIdFullData.shoptype != 1 ? '非'
              : '' }}授权违规流程处理。</span>
          </el-tag>
        </div>
        <!-- <div class="hint_word_orange">
          <i class="el-icon-warning"></i>
          当前店铺为{{getByIdFullData.shoptype!=1?'非':''}}授权店铺，接受举报后将按照{{getByIdFullData.shoptype!=1?'非':''}}授权违规流程处理。
        </div> -->
        <el-card class="margin_top20">
          <el-form label-width="100px">
            <el-form-item label="初审结果:" required>
              <el-radio label="1" border size="small" class="no_circle_radio" v-model="firsttrial.status"
                @change="ifCanNextBtn">接受举报</el-radio>
              <el-radio label="10" border size="small" class="no_circle_radio" v-model="firsttrial.status"
                @change="ifCanNextBtn">驳回举报</el-radio>
            </el-form-item>
            <el-form-item label="驳回说明" v-show="firsttrial.status === '10'" required>
              <el-input type="textarea" placeholder="请输入驳回说明，请保持在200字以内。" maxlength="200"
                v-model="firsttrial.reportexplain" class="check_textarea"></el-input>
            </el-form-item>
            <el-form-item label="驳回图片" v-show="firsttrial.status === '10'">
              <uploadPic @getpic="getRejectPic" :imgList="rejectPicInitList"></uploadPic>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
      <!-- 举报驳回 -->
      <el-card class="margin_top20" v-if="activeName === 'second'">
        <el-form label-width="100px">
          <el-form-item label="初审结果：">驳回举报</el-form-item>
          <el-form-item label="驳回说明：">{{ getByIdFullData.reportexplain }}</el-form-item>
          <el-form-item label="驳回图片：" v-if="reportPicArr.length">
            <div class="reject_pic_wrap">
              <div class="reject_pic_item" v-for="(item, index) in reportPicArr" :key="index"
                @click="openRejectPic(index)">
                <img :src="item" alt="驳回图片" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="初审人：">{{ getByIdFullData.flowusername }}</el-form-item>
          <el-form-item label="初审时间：">{{ getByIdFullData.createtime | fullTime }}</el-form-item>
        </el-form>
      </el-card>

      <div class="flex_end margin_top20" v-if="activeName === 'first'">
        <el-button type="confire_btn" size="small" @click="firstTrialpost" :disabled="canNextBtn">确定</el-button>
        <el-button type="cancel_blue" size="small" @click="drawer = false">取消</el-button>
      </div>
    </el-drawer>
    <el-dialog title="提示" :visible.sync="repetitionShow" width="20%" style="margin-top: 10%;" class="hint_dialog">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">当前举报链接已被举报，且在店铺整改时</div>
          <div style="font-size: 14px;">时范围内，暂不支持重复举报</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="repetitionShow = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import commonReportInfo from "@/views/CreditScore/common/commonReportInfo";
import dealTitle from "@/views/CreditScore/common/dealMainInfo/dealTitle";
import uploadPic from "@/views/CreditScore/common/uploadPic";

export default {
  props: {
    activeName: {
      type: String
    }
  },
  data() {
    return {
      drawer: false,
      firsttrial: {
        status: "",
        reportexplain: "",
        reportpic: ""
      },
      repetitionShow: false,
      canNextBtn: true
    };
  },
  computed: {
    ...mapState({
      creditShopid: state => state.creditScore.creditShopid
    }),
    ...mapGetters(["getByIdFullData"]),
    // 驳回图片列表（second 状态回显，store 的 getById 已将 reportpic 转为数组，兼容字符串形态）
    reportPicArr() {
      let pic = this.getByIdFullData.reportpic;
      if (!pic) return [];
      return typeof pic === "string" ? pic.split(",") : pic;
    },
    // 驳回图片上传区初始回显（first 状态下字段为空，仅用于组件 created 初始化）
    rejectPicInitList() {
      let pic = this.firsttrial.reportpic;
      return pic ? pic.split(",") : [];
    }
  },
  components: { commonReportInfo, dealTitle, uploadPic },

  methods: {
    ...mapMutations(["saveCreditChangeShopId"]),
    loadPage() {
      this.$emit('loadDataNowPage')
    },
    ifCanNextBtn() {
      let data = this.getByIdFullData;
      let val = this.firsttrial.status
      if (val == 1) {
        if (
          data.shopname &&
          data.productinfo &&
          data.platform_code &&
          data.reporturl
        ) {
          this.canNextBtn = false;
        } else {
          if (!data.shopname) {
            this.$message({ type: "warning", message: "请在修改信息中添加店铺名称" });
          }
          if (!data.platform_code) {
            this.$message({ type: "warning", message: "请在修改信息中添加平台" });
          }
          if (!data.reporturl) {
            this.$message({ type: "warning", message: "请在修改信息中添加违规链接" });
          }
          this.canNextBtn = true;
          if (this.getByIdFullData.creatuser != '匿名举报') {
            if (!data.productinfo) {
              this.$message({ type: "warning", message: "请在修改信息中添加产品信息" });
            }
            this.canNextBtn = true;
          } else {
            console.log('匿名举报');
            this.canNextBtn = false;
          }

        }
      } else if (val == 10) {
        this.canNextBtn = false;
      }
    },
    showDrawer() {
      this.canNextBtn = true;
      this.drawer = true;
      this.ifCanNextBtn()
      this.saveCreditChangeShopId({
        shopid: this.getByIdFullData.shopid,
        shoptype: this.getByIdFullData.shoptype
      });
    },
    closeDrawer() {
      this.firsttrial = {};
    },
    changeRepetitionShow() {
      this.repetitionShow = true;
    },
    // 驳回图片上传回调，uploadPic 回传逗号拼接的图片地址
    getRejectPic(val) {
      this.firsttrial.reportpic = val;
    },
    // 驳回图片预览（新窗口打开，处理地址含 + 号的转义，与 commonReportInfo 保持一致）
    openRejectPic(index) {
      let file = this.reportPicArr[index];
      if (/\+/.test(file)) {
        let fileFirst = file.slice(0, file.indexOf("_") + 1);
        let fileName = encodeURIComponent(file.slice(file.indexOf("_") + 1));
        fileName = fileName.replace(/\(/g, "%28");
        fileName = fileName.replace(/\)/g, "%29");
        file = fileFirst + fileName;
      }
      window.open(file);
    },
    firstTrialInfo() {
      this.canNextBtn = false;
    },
    firstTrialpost() {
      let data = {};
      if (!this.firsttrial.status) {
        this.$message({ type: "warning", message: "请选择初审结果" });
        return false;
      }
      //客服初审中
      if (this.firsttrial.status == 10) {
        //驳回举报
        if (this.firsttrial.reportexplain == "") {
          this.$message({ type: "warning", message: "请输入驳回说明" });
          return false;
        }
        data = this.firsttrial;
      } else {
        data.status = 1; //接收
      }
      data.reportid = this.getByIdFullData.id;
      let params = Object.assign({}, data, this.creditShopid);
      fetch({
        url: "hcm/hcmReport/updateStatus",
        method: "post",
        data: params
      }).then(res => {
        if (res.status == "10000") {
          this.$message({ type: "success", message: "成功" });
          this.drawer = false;
          this.firsttrial = {};
          this.$emit("loadDataPage");
        } else {
          this.$message({ type: "error", message: res.message });
        }
      });
    }
  }
};
</script>
<style lang="scss">
@import "style/fontSize.scss";

#checkInfo {
  .el-drawer {
    background-color: rgba(240, 242, 245, 1) !important;
  }

  .el-drawer .el-drawer__header {
    background-color: white;
  }

  .hint_word_orange {
    margin-top: 20px;
  }

  .await_icon2 {
    margin-right: 5px;
  }

  .auto_complete {
    width: 196px;
  }

  .edit_icon {
    margin-left: 5px;
  }

  .drawer-subtitle_common {
    margin: 0;
  }

  .info_header {
    margin: 20px 0;
  }

  .margin_top20 {
    margin-top: 20px;
  }

  .g-margin-left {
    margin-left: 0;
  }

  .check_textarea {
    width: 392px;

    .el-textarea__inner {
      height: 90px;
    }
  }

  .reject_pic_wrap {
    display: flex;
    flex-wrap: wrap;

    .reject_pic_item {
      width: 100px;
      height: 100px;
      margin-right: 10px;
      margin-bottom: 10px;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
      border: 1px solid #e4e7ed;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
